import { inflate, deflate } from 'pako'

/**
 * @function decompressData
 * @description Descomprime un Uint8Array (esperado de pako.deflate) a un string JSON y luego lo parsea.
 * @param {Uint8Array} compressedValue - El valor Uint8Array comprimido.
 * @returns {any|null} El valor descomprimido y parseado, o `null` si la entrada no es Uint8Array
 * o si ocurre un error durante la descompresión o el parseo.
 */
export const decompressData = compressedValue => {
  if (!(compressedValue instanceof Uint8Array)) {
    console.error('Error en decompressData: la entrada no es Uint8Array.', compressedValue)
    return null
  }
  try {
    const jsonString = inflate(compressedValue, { to: 'string' })
    return JSON.parse(jsonString)
  } catch (decompressionError) {
    console.error('Error descomprimiendo o parseando datos:', decompressionError)
    return null
  }
}

/**
 * @function compressData
 * @description Serializa un valor a JSON y luego lo comprime usando pako.
 * @param {any} plainValue - El valor que se desea serializar y comprimir.
 * @returns {Uint8Array|null} Un Uint8Array con los datos comprimidos,
 * o `null` si el valor es null/undefined o si ocurre un error durante la compresión.
 */
export const compressData = plainValue => {
  if (plainValue === null || typeof plainValue === 'undefined') {
    // No se puede comprimir null o undefined de esta manera,
    // la capa de almacenamiento decidirá cómo manejarlos (ej. almacenarlos tal cual).
    // Devolver null para indicar que no hay datos comprimidos.
    return null
  }
  try {
    const stringifiedValue = JSON.stringify(plainValue)
    return deflate(stringifiedValue) // pako.deflate devuelve Uint8Array
  } catch (error) {
    console.error('Error comprimiendo datos:', error)
    return null
  }
}
